import React from 'react'
import Hero from './components/hero'

function Contact() {
  return (
    <div>
      <Hero />
    </div>
  )
}

export default Contact
